module.exports = __webpack_public_path__ + "static/media/goodpin.15d4fd81.svg";